module.exports = new __parcel__URL__("bat.3a3e8172.svg").toString();